import { render } from "./Game.vue?vue&type=template&id=513c4d15"
import script from "./Game.vue?vue&type=script&lang=js"
export * from "./Game.vue?vue&type=script&lang=js"

import "./Game.vue?vue&type=style&index=0&id=513c4d15&lang=css"

import exportComponent from "/Users/corentin/Documents/Projets/Wordle/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__